import { createGlobalStyle } from "styled-components";
import iransans from "assets/fonts/IRANSansWeb.ttf";
import iransansBold from "assets/fonts/IRANSansWeb_Bold.ttf";
import vazirRegular from "assets/fonts/Vazir-Regular.ttf";
import vazirBold from "assets/fonts/Vazir-Bold.ttf";
import vazirBlack from "assets/fonts/Vazir-Black.ttf";

import colors from "constants/palette";

const GlobalStyle = createGlobalStyle`
 @font-face {
  font-family: "iransans";
  src: local("IRANSans"), url(${iransans}) format("truetype");
}
@font-face {
  font-family: "iransansBold";
  src: local("IranSansBold"),
    url(${iransansBold}) format("truetype");
}

@font-face {
  font-family: "vazir";
  src:local("vazir"),
    url(${vazirRegular}) format("truetype");;
    font-weight: normal;
    font-weight: 500;
  }
@font-face {
  font-family: "vazir";
  src:local("va"),
    url(${vazirBold}) format("truetype");;
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "vazir";
  src:local("vaz"),
    url(${vazirBlack}) format("truetype");;
  font-weight: bolder;
  font-weight: 900;
  font-style: normal;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;border-radius: 12px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;border-radius: 12px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'iransans';
}
code {
  background: #171717;
  color: #0dc80d;
  padding: 2px 14px;
  border-radius: 4px;
}
label {
  color: ${colors.dark} !important;
}
.row {
  display: flex;
  align-items: center;
}
.center {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}



/* ant custom */

/* table */
.ant-table-pagination.ant-pagination {
    display: flex !important;
    justify-content: flex-start !important;
    direction: rtl !important;
}

.ant-picker-panel-container {
  background-color: ${colors.white} !important;
  color: ${colors.dark} !important;
}
.ant-picker-content th ,.ant-picker-content td ,.ant-picker-header, .ant-picker-header>button{
  color: ${colors.dark} ;
}

.ant-picker-cell:hover .ant-picker-cell-inner {
  background-color: ${colors.primary + "20"} !important ;
}
.ant-picker-header>button:hover {
 color: ${colors.primary} !important ;
}
& .ant-modal {
padding:0;
  }
& .ant-modal-body  div {
/* color:${colors.dark} */
  }
& .ant-modal-footer {
  padding-bottom: 14px;
  }
& .ant-radio-button-wrapper {
  background-color: ${colors.white + "40"} ;
  }
  & .ant-radio-button-wrapper , .ant-radio{
  color: ${colors.dark} !important;
  }
& .ant-radio-button-wrapper:focus-within {
  box-shadow: none !important;  }
& .ant-radio-button-wrapper-checked {
  color:${colors.dark} !important;  }
& .ant-radio-inner {
  background-color: ${colors.white} !important;
    border: 1px solid  ${colors.dark + "80"} !important;  }

  & .ant-radio-button-wrapper-checked  span { 
    color: ${colors.white} !important;
  }

/* List items content */
& .ant-list-item-meta-content {
  text-align: right;
  padding-right:12px ;
}

& .ant-popover-inner-content ,.ant-popover-arrow-content{
    background: ${colors.white};
  }
    & .ant-list-item-meta-title > a,.ant-list-item-meta-description,.ant-list * {
  color: ${colors.dark}
    }


&  .ant-steps-item-process>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title {
  color: ${colors.dark} ;
}
& .ant-steps-item-wait>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title {
  color: ${colors.dark + "9a"} ;
}
& .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title {
  color: ${colors.dark + "d6"} ;
}
& .ant-steps-item-wait .ant-steps-item-icon {
  background: ${colors.white} ;
  border-color: ${colors.dark + "9a"} ;
 
}
& .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon {
    color: ${colors.dark + "70"} ;
  }
&  .ant-input-number-input {
  background: ${colors.white + "40"} ;
  }

  & .ant-cascader-menus.ant-cascader-rtl {
    flex-direction: row-reverse;
  }

  & ul.ant-cascader-menu {
    height: auto;
    max-height: 60vh;

    direction: rtl;
  }
`;

export default GlobalStyle;
